function CardPiles(props) {    

    return(
            <>
            <img className='cardPile' id={props.id} src={props.src} />
            </>
    )
}

export default CardPiles;